<ng-container *ngIf="cellValue">
  <div class="bold">{{ cellLabel }}:</div>
  <table class="w-100">
    <tr>
      <th></th>
      <th *ngFor="let header of headers">{{ header }}</th>
    </tr>
    <tr *ngFor="let row of rows">
      <td>{{ row.label }}:</td>
      <td *ngFor="let field of row.fields">{{
        cellValue[field] | number : decimalFormat
      }}</td>
    </tr>
    <tr *ngIf="summary && totals" class="summary">
      <td>
        {{ summary.label }}
      </td>
      <td *ngFor="let total of totals; let index = index">
        <span *ngIf="summary?.addonLeft?.[index]">
          {{ summary.addonLeft[index] }}
        </span>
        {{ total | number : summary.decimalFormat || '1.2' }}
      </td>
    </tr>
  </table>
</ng-container>
